$(document).ready(function(){    
  
  $(".slick_slide").owlCarousel({	
    navigation: true,
    navText: ['<svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 32" width="38" height="32"> <style> tspan { white-space:pre } .shp0 { fill: #f8971d } </style> <g id="Group 3"> <path id="Shape 12 copy 2" class="shp0" d="M15.86 11.93L13.55 11.93L13.55 6.58L4.23 16L13.55 25.41L13.55 20.06L15.86 20.06L15.86 30.99L1.01 16L15.86 1L15.86 11.93ZM36 14.83L15.28 14.83L15.28 17.16L36 17.16L36 14.83Z"/> </g> </svg>','<svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 32" width="38" height="32"> <style> tspan { white-space:pre } .shp0 { fill: #f8971d } </style> <path id="Shape 12 copy" class="shp0" d="M22.14 11.93L24.45 11.93L24.45 6.58L33.77 16L24.45 25.41L24.45 20.06L22.14 20.06L22.14 30.99L36.99 16L22.14 1L22.14 11.93ZM2 14.83L22.72 14.83L22.72 17.16L2 17.16L2 14.83Z"/> </svg>'],
    dots: false,
    autoPlay: true,
    slideSpeed : 1000,
    autoplaySpeed: 4000,
    mouseDrag: true,
    items: 4,
    loop:true,
    responsiveClass:true,
    responsive:{
      0:{
        items:1,
        nav:true
      },
      600:{
        items:2,
        nav:false
      },
      992:{
        items:3,
        nav:true,
        loop:false
      },
      1200:{
        items:4,
        nav:true,
        loop:false
      }
    }
  });

//   $('.slick_slide').slick({
//     dots: false,
//     infinite: true,
//     speed: 2000,
//     autoplay:false,
//     arrows: true,
//     slidesToShow: 4,
//     slidesToScroll: 4,
//     prevArrow:'<button type="button" class="slick-prev pull-left"><svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 32" width="38" height="32"> <style> tspan { white-space:pre } .shp0 { fill: #f8971d } </style> <g id="Group 3"> <path id="Shape 12 copy 2" class="shp0" d="M15.86 11.93L13.55 11.93L13.55 6.58L4.23 16L13.55 25.41L13.55 20.06L15.86 20.06L15.86 30.99L1.01 16L15.86 1L15.86 11.93ZM36 14.83L15.28 14.83L15.28 17.16L36 17.16L36 14.83Z"/> </g> </svg></button>',
//     nextArrow:'<button type="button" class="slick-next pull-right"><svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 32" width="38" height="32"> <style> tspan { white-space:pre } .shp0 { fill: #f8971d } </style> <path id="Shape 12 copy" class="shp0" d="M22.14 11.93L24.45 11.93L24.45 6.58L33.77 16L24.45 25.41L24.45 20.06L22.14 20.06L22.14 30.99L36.99 16L22.14 1L22.14 11.93ZM2 14.83L22.72 14.83L22.72 17.16L2 17.16L2 14.83Z"/> </svg></button>',
//     responsive: [
//       {
//         breakpoint: 1281,
//         settings: {
//           speed: 1000,
//           arrows: true,
//           centerMode: true,
//           centerPadding: '100px',
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       },
//       {
//         breakpoint: 992,
//         settings: {
//           arrows: true,
//           centerMode: true,
//           centerPadding: '60px',
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           centerMode: false,
//           centerPadding: '0px',
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       },
//       {
//         breakpoint: 576,
//         settings: {
//           speed: 500,
//           autoplay:false,
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });


  $('.slide-content').hide()
  //----- click function
  $("#accordion").find("div[role|='button']").click(function() { //---- tabs or buttons
    //---- active class
    $("#accordion").find("div[role|='button']").removeClass('active');
    $('.slide-content').slideUp('slow');
    var selected = $(this).next('.slide-content');
    if (selected.is(":hidden")) {
      $(this).next('.slide-content').slideDown('slow');
      $(this).toggleClass('active');
    }
  });

});

$(window).bind('load',function(){
  $('.custom-loader').fadeOut(500);
});